module.exports = __webpack_public_path__ + "static/media/longOShortOPairs.3baa78a6.mp3";